var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 21.3332C10.6665 20.6259 10.9475 19.9477 11.4476 19.4476C11.9476 18.9475 12.6259 18.6665 13.3332 18.6665H34.6665C35.3737 18.6665 36.052 18.9475 36.5521 19.4476C37.0522 19.9477 37.3332 20.6259 37.3332 21.3332V30.6665C37.3332 31.3737 37.0522 32.052 36.5521 32.5521C36.052 33.0522 35.3737 33.3332 34.6665 33.3332H29.5092C29.0487 33.3332 28.596 33.2139 28.1953 32.987C27.7946 32.7602 27.4594 32.4334 27.2225 32.0385L25.1425 28.5718C25.024 28.3747 24.8564 28.2116 24.6562 28.0983C24.456 27.9851 24.2299 27.9256 23.9998 27.9256C23.7698 27.9256 23.5437 27.9851 23.3435 28.0983C23.1432 28.2116 22.9757 28.3747 22.8572 28.5718L20.7772 32.0385C20.5402 32.4334 20.2051 32.7602 19.8044 32.987C19.4037 33.2139 18.951 33.3332 18.4905 33.3332H13.3332C12.6259 33.3332 11.9476 33.0522 11.4476 32.5521C10.9475 32.052 10.6665 31.3737 10.6665 30.6665V21.3332ZM13.0838 17.0412C13.5708 16.3109 14.2304 15.7121 15.0042 15.2978C15.778 14.8836 16.6421 14.6667 17.5198 14.6665H30.4772C31.3551 14.6665 32.2195 14.8833 32.9936 15.2975C33.7676 15.7118 34.4275 16.3107 34.9145 17.0412L35.9998 18.6665H11.9998L13.0838 17.0412V17.0412Z",
    stroke: "#FEF335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr);
export default __webpack_public_path__ + "static/media/VR.26074c691f38b6a317d1e2ebebc3218b.svg";
export { ForwardRef as ReactComponent };